import React from 'react';
import {
  Icon,
  Header,
} from 'semantic-ui-react';

const style = {
  mainSeg: {
    paddingTop: '15em',
    paddingBottom: '15em',
    textAlign: 'center'
  }
};

export const ErrorDisplay = ({message}) => (
  <div style={style.mainSeg}>
    <Header as='h1' icon>
      <Icon name='remove circle' color='red' />
      Error
      <Header.Subheader>{message}</Header.Subheader>
    </Header>
  </div>
);

export default ErrorDisplay;
